$(function() {
  var cartDrawer = $(".cart-drawer");
  $(window).scroll(function() {    
      var scroll = $(window).scrollTop();
  
      if (scroll >= 50) {
          cartDrawer.addClass("cart-drawer--position");
      } else {
          cartDrawer.removeClass("cart-drawer--position");
      }
  });
});

  document.querySelector('.overlay').addEventListener("click", e => {
    document.querySelector('.overlay').classList.remove("active");
    document.querySelector('.burger-wrapper__menu').classList.remove('active');
    document.body.classList.remove('lock');
    document.querySelectorAll(".has-children").forEach(e => e.classList.remove("active"));
    iconMenu.classList.remove("active");
    if(twoColumnSwitcher){
      twoColumnSwitcher.classList.add('active');
      oneColumnSwitcher.classList.add('active');
    }
  })
  const navigation = document.querySelectorAll('.navigation__submenu');

 for (let i = 0; i < navigation.length; i++) {
    navigation[i].addEventListener("mouseleave", function() {
      document.querySelector('.overlay').classList.remove("active");
      document.querySelector('.burger-wrapper__menu').classList.remove('active');
      document.body.classList.remove('lock');
      document.querySelectorAll(".has-children").forEach(e => e.classList.remove("active"));
      if(twoColumnSwitcher){
        twoColumnSwitcher.classList.add('active');
        oneColumnSwitcher.classList.add('active');
      }
     });
 }
  document.querySelector('.header-cart-drawer').addEventListener("click", e => {
    document.querySelector('.overlay').classList.remove("active");
    document.querySelectorAll(".has-children").forEach(e => e.classList.remove("active"));
  })
  document.querySelector('.header__links-list').addEventListener("click", e => {
      
     if(!e.target.classList.contains("active")) {
      document.querySelector('.overlay').classList.add("active");
      document.body.classList.add('lock');
      document.querySelectorAll(".has-children").forEach(e => e.classList.remove("active"));
     } else {
      document.querySelector('.overlay').classList.remove("active");
      document.body.classList.remove('lock');
     }

     // toggle red class to the target
     e.target.classList.toggle("active");
  });

  function openQuickAdd(id){
    document.getElementById(id).classList.toggle("active");
  }
